import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import ModalPreview from "components/Common/ModalPreview";
import noImage1 from "../../../../assets/images/no-image-icon.png";
import inquiryListApi from "api/inquiryListApi";
import { formatDateStringToKorea } from "helpers/format";
import TextArea from "antd/es/input/TextArea";
import { Button, Collapse, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { INQUIRY_REPLY_TYPE } from "helpers/constans";
import UploadFile from "components/Common/UploadFile";
import BaiveAdminImg from "../../../../assets/images/admin_baive.png";
import CommentIcon from "../../../../assets/images/comment-icon.png";
import FileReader from "components/Common/FileRender";

registerLocale("en", en);
registerLocale("ko", ko);

export interface ISearch {
  page: number;
  limit: number;
  keyword: string;
}

export interface IFacility {
  id?: number;
  icon?: string;
  name?: string;
}

export interface IResFacilites {
  list?: IFacility[];
  meta?: {
    total: number;
    page: number;
    limit: number;
  };
}

const DEFAULT_DATA_SEARCH = {
  page: 1,
  limit: 100,
  keyword: "",
};

export interface IProps {
  barID?: any;
}

const UtilitiesList = ({ detail, data, reloadData }: any) => {
  const { t, i18n } = useTranslation();

  const [queryFacility, setQueryFacility] =
    useState<ISearch>(DEFAULT_DATA_SEARCH);

  const [linkImage, setLinkImage] = useState<any>();
  const [contents, setContents] = useState<any>();
  const [attachments, setAttachments] = useState<any>([]);
  const [isDisabled, setIsDisable] = useState<any>(false);

  const onCloseImageClick = () => {
    setLinkImage((_prev: any) => null);
  };

  async function replyInquiry() {
    setIsDisable(true);
    const body = {
      contents: contents,
      attachments: attachments,
    };
    const res = await inquiryListApi.createInquiry(detail?.id, body);
    if (res?.code == 200) {
      reloadData();
      setAttachments(null);
      setContents(null);
    }
    setIsDisable(false);
  }

  useEffect(() => {
    document.title = `${t("Utilities")} - ${t("Inquiry")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="mt-3">
        {data?.length > 0 && (
          <Card className="p-3">
            <h5
              style={{ color: "#71717A", fontWeight: 600 }}
              className="d-flex align-items-center gap-2"
            >
              <img src={CommentIcon} /> {t("Comment")} - {data?.length || 0}
            </h5>
            <div className="mt-3">
              {data?.map((i: any, index: number) => (
                <div>
                  <div className="d-flex gap-2 align-items-center">
                    {i?.reply_by_admin_id ? (
                      <>
                        <img src={BaiveAdminImg} height={25} />
                        <div style={{ fontWeight: 400 }}>
                          {i?.account_reply_info?.email}
                        </div>
                      </>
                    ) : (
                      <div style={{ fontWeight: 600 }}>
                        {i?.account_reply_info?.name}
                      </div>
                    )}
                    <div
                      style={{
                        color: "#8B8B8B",
                        fontSize: 11,
                      }}
                    >
                      {formatDateStringToKorea(
                        i?.created_at,
                        "YYYY-MM-DD HH:mm"
                      )}
                    </div>
                  </div>
                  <div className="mt-2" style={{ whiteSpace: "pre-line" }}>
                    {i?.contents}
                  </div>
                  <div className="d-flex gap-3 flex-wrap mt-2">
                    {i?.attachments?.map((i: any) => {
                      if (i?.type == "video")
                        return (
                          <video
                            width="160"
                            height="120"
                            controls
                            key={i?.path}
                            onClick={() => {
                              const newItem = {
                                type: "VIDEO",
                                url: i?.path,
                              };
                              setLinkImage(newItem);
                            }}
                          >
                            <source src={i?.path} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        );

                      if (i?.type == "image")
                        return (
                          <div>
                            <div
                              style={{ width: "90px" }}
                              className="cursor-pointer"
                              onClick={() => {
                                const newItem = {
                                  type: "IMAGE",
                                  url: i?.path,
                                };
                                setLinkImage(newItem);
                              }}
                            >
                              <img
                                src={i?.path}
                                className="flex-shrink-0 rounded w-100"
                                alt="thumbnail"
                              />
                            </div>
                          </div>
                        );
                      return <FileReader file={i} />;
                    })}
                  </div>

                  {index != data?.length - 1 && (
                    <div
                      style={{
                        background: "#E5E5E5",
                        width: "100%",
                        height: 1,
                        margin: "20px 0",
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
          </Card>
        )}

        <div style={{ height: 200 }}></div>

        <div
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            left: 0,
            paddingLeft: 20,
            paddingRight: 30,
            background: "white",
          }}
          className="inquiry_feedback"
        >
          <Collapse
            expandIconPosition="end"
            items={[
              {
                key: "1",
                label: t("Comment Section"),
                children: (
                  <div
                    id="customerList"
                    style={{
                      boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
                      margin: 0,
                      background: "#F8F8F8",
                    }}
                  >
                    <div className="p-3">
                      <TextArea
                        value={contents}
                        onChange={(e) => setContents(e.target.value)}
                        maxLength={500}
                        style={{ background: "#F8F8F8" }}
                        placeholder={t("Enter your feedback here...")}
                      />
                      <div className="text-end mt-2">
                        {contents?.length || 0}/500
                      </div>
                      <div className="d-flex justify-content-between mt-3 align-items-end">
                        <UploadFile
                          attachments={attachments}
                          setAttachments={setAttachments}
                          maxCount={5}
                          isUploadMore={true}
                        />
                        <div className="customized-blue-send">
                          <Button
                            onClick={() => replyInquiry()}
                            disabled={!contents || isDisabled}
                            type="primary"
                            style={{ borderRadius: 8 }}
                          >
                            {t("Send")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              },
            ]}
          />
        </div>
        <ModalPreview
          type={linkImage?.type}
          isOpen={!!linkImage}
          url={linkImage?.url}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default UtilitiesList;
